<template>
  <div class="app-container circle-new-edit">
    <basic-container v-loading="loading">
      <el-row type="flex" align="middle">
        <el-col :span="2" class="block-label">
          <div>专栏名称</div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-select 
              v-model="columnId"
              filterable remote :remote-method="getColumns" 
              @change="getColumnAuthor" placeholder="输入专栏名称搜索"
              :disabled="this.essay.id ? true: false">
              <el-option
                v-for="item in columnOptions"
                :key="item.id"
                :label="item.columnName"
                :value="item.id"
                >
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle">
        <el-col :span="2" class="block-label">
          <div>专栏作者</div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-input v-model.trim="author" :maxlength="30" disabled></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle">
        <el-col :span="2"  class="block-label">
          <div>文章标题</div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-input v-model.trim="essay.title" :maxlength="30" placeholder="输入文章标题" />
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div>封面</div>
        </el-col>
        <el-col :span="12">
          <div>
            <template v-if="!coverImgUrl">
              <el-upload
                ref="upload"
                :show-file-list="false"
                action=""
                accept="image/jpeg, image/png"
                :http-request="uploadFile"
                :before-upload="beforeFileUpload"
                list-type="picture-card"
                >
              <i class="el-icon-plus cover-uploader-icon"></i>  
              </el-upload>
            </template>
            <template v-else>
              <div class="cover-img-block">
                <img :src="coverImgUrl" class="origin-cover"/>
                <div class="delete-coverimg" @click="handleImageRemove">
                  <img src="@/static/images/editor/delete.svg"/>
                </div>
              </div>
            </template>
          </div>
        </el-col>
      </el-row>
      <el-row style="margin: 10px 0px;">
        <el-col :span="2">
          <div>内容</div>
        </el-col>
        <el-col :span="12">
          <div class="essayContent">
            <block-editor :contentList="essay.content" v-model="essayContentList"></block-editor>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :offset="2">
          <el-checkbox v-model="essay.commentDisabled" :disabled="essay.id ? true : false">关闭评论</el-checkbox>
        </el-col>
      </el-row>
      <div class="operation">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </div>
    </basic-container>
  </div>
</template>
<script>
import { getCirclesAdmin, getAllCircleMembersAdmin } from '@/api/post/circle'
import { createPost, updatePost, getPost } from '@/api/post/post'
import BlockEditor from '@/components/block-editor/BlockEditor'
import { getFileKey } from '@/util/util';
import { getOSSSign, uploadImage } from '@/api/basic/aliyunoss';
const initPage = vm => {
  vm.getColumns();
}
export default {
  components: {
    BlockEditor,
  },
  data () {
    return {
      loading: false,
      columnOptions: [],
      columnId: '',
      author: '',
      coverImgUrl: '',
      essay: {
        id: '',
        title: '',
        commentDisabled: false,
        content: [],
      },
      essayContentList: [],
      uploadImgLoading: {},
    }
  },
  mounted () {
    if (this.$route.query.id) {
      this.essay.id = this.$route.query.id;
      this.getEssayInfo();
    } else {
      initPage(this);
    }
  },
  methods: {
    beforeFileUpload(file) {
      const imageType = file.type ? file.type.toLowerCase() : '';
      if (imageType !== 'image/jpeg' && imageType !== 'image/png') {
        this.$message.error('仅支持jpg、png格式');
        return false;
      }
      return true;
    },
    handleImageRemove () {
      this.coverImgUrl = '';
    },
    uploadFile(option) {
      // 获取文件路径名
      getFileKey(option.file, (fileKey) => {
        this.uploadImgLoading = this.$loading({});
        // 获取阿里云签名
        getOSSSign().then(response => {
          let cdnHost = response.data.data.cdnHost
          let host = response.data.data.host;
          let params = new FormData();
          params.append('name', option.file.name)
          params.append('key', fileKey)
          params.append('policy', response.data.data.policy)
          params.append('OSSAccessKeyId', response.data.data.accessKeyId)
          params.append('success_action_status', 200)
          params.append('signature', response.data.data.signature)
          params.append('file', option.file, option.file.name)
          uploadImage(host, params).then(response => {
            this.coverImgUrl = `${cdnHost}/${fileKey}?x-oss-process=image/resize,m_fill,w_148,h_148`;
            this.uploadImgLoading.close();
          }).catch(error => {
            this.$message({
              message: '上传失败',
              type: 'error'
            });
          });
        }).catch((error) => {
          this.$message({
            showClose: true,
            message: '图片上传失败',
            type: 'error',
          });
        });
      })
    },
    getColumns(columnName) {
      const queryData = {
        circleType: 1,
        name: columnName,
      };
      getCirclesAdmin(queryData).then(response => {
        if (Array.isArray(response.data.data.records)) {
          this.columnOptions = response.data.data.records.map(x => {
            return {
              id: x.id,
              columnName: x.circleName
            }
          })
        }
      })
    },
    getColumnAuthor() {
      if (!this.columnId) {
        return;
      }
      const queryData = {
        circleType: 1,
        circleId: this.columnId,
        memberType: 1,
      };
      getAllCircleMembersAdmin(queryData).then(response => {
        this.author = response.data.data.records[0].name;
      })
    },
    cancel () {
      this.$router.$avueRouter.closeTag()
      this.$router.go(-1)
    },
    validatePublishEssay() {
      let resultOK = true;
      if (!this.columnId) {
        this.$message({
          showClose: true,
          message: '请选择发布文章的专栏',
          type: 'error',
        });
        return false;
      }
      if (this.essay.title === null || this.essay.title.trim().length < 1) {
        this.$message({
          showClose: true,
          message: '文章标题不能为空',
          type: 'error',
        });
        return false;
      }
      const textBlock = this.essayContentList.filter((item) => item.type === 'text');
      let existContent = false;
      for (let i = 0; i < textBlock.length; i += 1) {
        if (textBlock[i].content || textBlock[i].content.trim().length > 0) {
          existContent = true;
          break;
        }
      }
      if (!this.essayContentList || !textBlock || textBlock.length < 1 || !existContent) {
        this.$message({
          showClose: true,
          message: '文章内容不能为空',
          type: 'error',
        });
        return false;
      }
      return resultOK;
    },
    prePublishHandleData(data) {
      const allContent = [];
      if (data.coverImg) {
        data.coverImg = data.coverImg.indexOf('?') === -1 ? data.coverImg : data.coverImg.split('?')[0].toString();
      }
      this.essayContentList.forEach((item) => {
        const tempItem = {};
        switch (item.type) {
          case 'text':
            tempItem.type = item.type;
            tempItem.content = item.content;
            break;
          case 'image':
            tempItem.type = item.type;
            tempItem.src = item.src[0].indexOf('?') === -1 ? item.src[0] : item.src[0].split('?')[0].toString();
            tempItem.caption = item.caption;
            break;
          case 'link':
            tempItem.type = item.type;
            tempItem.href = item.href;
            tempItem.title = item.title;
            break;
          case 'video':
            tempItem.type = item.type;
            tempItem.src = item.src;
            tempItem.thumbnail = item.thumbnail;
            tempItem.caption = item.caption;
            break;
          case 'qq-video':
            tempItem.type = item.type;
            tempItem.src = item.src;
            tempItem.vid = item.vid;
            tempItem.caption = item.caption;
            break;
          default:
            break;
        }
        allContent.push(tempItem);
      });
      data.content = JSON.stringify(allContent);
    },
    modifyArticle(params, modify, msg, errorMsg, request) {
      modify(params).then((res) => {
        const code = res.status;
        const data = res.data;
        console.log('data', data);
        if (code === 200) {
          if (data.code === 0) {
            this.$message({
              showClose: true,
              message: msg,
              type: 'success',
              duration: 1500,
              onClose: () => { 
                if (request === 'create') {
                  this.$router.push({ path: `/post/essay/detail/${data.data}` });
                } else {
                  this.$router.push({ path: `/post/essay/detail/${this.essay.id}` });
                }
              }
            });
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error',
            });
          }
        }
      }).catch((err) => {
        this.$message({
          showClose: true,
          message: errorMsg,
          type: 'error',
        });
      });
    },
    submit () {
      if (!this.validatePublishEssay()) {
        return;
      }
      const postData = {};
      postData.circleId = this.columnId;
      postData.title = this.essay.title;
      postData.coverImg = this.coverImgUrl;
      postData.tagName = '文章';
      postData.postType = 1;
      postData.contentType = 3;
      postData.commentEnabled = !this.essay.commentDisabled;
      this.prePublishHandleData(postData);
      console.log('postData', postData);
      if (this.essay.id) {
        postData.id = this.essay.id;
        this.modifyArticle(postData, updatePost, '文章编辑成功', '文章编辑失败，请稍后重试！', 'update');
      } else {
        postData.commentEnabled = !this.essay.commentDisabled;
        this.modifyArticle(postData, createPost, '文章发布成功', '文章发布失败，请稍后重试！', 'create');
      }
    },
    getEssayInfo() {
      getPost(this.essay.id).then((res) => {
        const data = res.data.data;
        if (res.data.code === 0) {
          this.essay.title = data.title;
          this.essay.commentDisabled = !data.commentEnabled;
          this.author = data.postedBy.name;
          this.columnOptions = [{
            id: data.circleId,
            columnName: data.circleName
          }];
          this.columnId = data.circleId;
          if (data.coverImg !== null && data.coverImg) {
            this.coverImgUrl = data.coverImg.concat('?x-oss-process=image/resize,m_fill,w_148,h_148');
          }
          if (data.contentType === 3) {
            this.essay.content = JSON.parse(data.content);
          } else {
            const contentItem = [{
              type: 'text',
              content: data.content,
            }];
            this.essay.content = contentItem;
          }
        }
      });
    },
  },
}
</script>
<style lang="scss">
.circle-new-edit {
  .cover-img-block {
    .origin-cover {
      width: 148px;
      height: 148px;
      float: left;
      margin-right: 8px;
    }
    .delete-coverimg {
      position: absolute;
      left: 140px;
      top: 50px;
      visibility: hidden;
    }
  }
  .cover-img-block:hover .delete-coverimg{
    visibility: visible;
  }
  .cover-uploader-icon {
    line-height: 148px;
  }
  .operation {
    text-align: center;
  }
  .block-label {
    line-height: 46px;
  }
  .essayContent {
    width: 940px;
    border: 1px solid #cccc;
    text-align: center;
  }
}
</style>

